export enum Weekday {
  // Sun = 0 will ensure the correct order when converting the enum to an array.
  // Also, the getDay() method returns the day of the week for the specified date
  // according to local time, where 0 represents Sunday
  Sun = 0,
  Mon,
  Tue,
  Wed,
  Thu,
  Fri,
  Sat,
}

export type CalendarDay = {
  day: number;
  month: number;
  year: number;
  active: boolean;
  selected: boolean;
};

export enum ViewMode {
  day = 'day',
  month = 'month',
  year = 'year',
}

export enum OutputDateFormatType {
  ddMMM = 'ddMMM',
  ddMMMM = 'ddMMMM',
  ddMMMyyyy = 'ddMMMyyyy',
  ddMMMMyyyy = 'ddMMMMyyyy',
}
